import React from 'react'

const Contact = () => {
  return (
    <div name='contact' className='w-full h-screen text-gray-300 bg-[#0a192f] flex justify-center items-center p-4'>
        <form method='POST' action="https://getform.io/f/9e4c714f-f3ca-4298-b50c-096ed99b9028" className='flex flex-col max-w-[600px] w-full'>
            <div className='pb-8'>
                <p className='text-4xl font-bold inline border-b-4 border-pink-600'>Kontakt</p>
                <p className='py-4'>// Täitke vorm siin või kirjutage meil - vakkumkaspar@gmail.com</p>
            </div>
            <input className='bg-[#ccd6f6] p-2' type="text" placeholder='Name' name='name' />
            <input className='my-4 p-2 bg-[#ccd6f6]' type="email" placeholder='Email' name='email' />
            <textarea className='bg-[#ccd6f6] p-2' name="message" rows="10" placeholder='Message'></textarea>
            <button className='text-white border-2 hover:bg-pink-600 hover:border-pink-600 px-4 py-3 my-8 mx-auto flex items-center'>Saada</button>
        </form>
    </div>
  )
}

export default Contact